module.exports = __webpack_public_path__ + "static/media/Any-Decision.0d55765c.mp4";